import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { PushDeviceControl } from "@amtana/push-client";

// No screen of its own: push only lends notification's settings screen its
// "this device" control (modules.md § How modules talk).
export const pushBrowserModule: BrowserModule = defineBrowserModule("push").withLends([
  { token: PushDeviceControl, load: () => import("./ui/blocks/push-device-control.tsx") },
]);
